import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import environments from '@src/configs/environments';
import type {
  IGovernanceAction,
  PaginatedGovernanceAction,
  PaginatedIndexedGovernanceAction,
} from '@src/models/types';
import type { getProposalListRequest } from './types';

export const GOVERNANCE_ACTION_PATH = 'governanceAction';
const GOVERNANCE_ACTION_TAG = 'governanceActionTag';
export const governanceActionApi = createApi({
  reducerPath: GOVERNANCE_ACTION_PATH,
  tagTypes: [GOVERNANCE_ACTION_TAG],
  refetchOnReconnect: true,
  refetchOnMountOrArgChange: true,
  keepUnusedDataFor: 0,
  baseQuery: fetchBaseQuery({
    baseUrl: environments.BASE_API_URL,
    credentials: 'include',
    prepareHeaders: (headers) => {
      headers.append('Content-Type', 'application/json');
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getProposalById: builder.query<IGovernanceAction, string>({
      query: (id) => ({
        url: `/proposal/${id}?vote_count=true`,
        method: 'GET',
      }),
    }),
    getProposals: builder.query<
      PaginatedGovernanceAction,
      getProposalListRequest
    >({
      query: ({ page, size, query, sort, type }) => ({
        url: `/proposal`,
        method: 'GET',
        params: {
          page,
          size,
          proposal: query,
          sort,
          type,
        },
      }),
    }),
    getIndexedProposals: builder.query<
      PaginatedIndexedGovernanceAction,
      getProposalListRequest
    >({
      query: ({ page, size, query, sort, type }) => ({
        url: `/proposals/indexed`,
        method: 'GET',
        params: {
          page,
          size,
          proposal: query,
          sort,
          type,
        },
      }),
    }),
  }),
});

export const {
  useGetProposalByIdQuery,
  useLazyGetProposalByIdQuery,
  useGetProposalsQuery,
  useGetIndexedProposalsQuery,
} = governanceActionApi;
